module.exports = __webpack_public_path__ + "media/xiaoman_01_时间慢.5c7f1a05.wav";